export const AUTH_CALLBACK_CODE = {
	FAILED: 'auth_callback_failed',
	NO_ACCESS: 'auth_no_access',
	CANCELLED: 'auth_callback_cancelled',
} as const;

export type AuthCallbackCode = (typeof AUTH_CALLBACK_CODE)[keyof typeof AUTH_CALLBACK_CODE];
